import { themeObject } from '../../../../lib/util/themes/godzilla';
import * as yup from 'yup';

export interface OwnersAndLimitedOwnersData {
    id: string;
    value: string;
}

export interface UploadFileFormInputs {
    operation: string;
    chain: string;
    fileType: string;
    owners: string[];
    limitedOwners: string[];
}

export const UploadFileSchema = yup.object({
    operation: yup.string().required(),
    chain: yup.string().required(),
    fileType: yup.string().required(),
    owners: yup.array().of(
        yup.object({
            id: yup.string(),
            value: yup.string(),
            header: yup.string(),
            subtitle: yup.string(),
        })
    ),
    limitedOwners: yup.array().of(
        yup.object({
            id: yup.string(),
            value: yup.string(),
            header: yup.string(),
            subtitle: yup.string(),
        })
    ),
});

export const uploadFileDefaults = {
    operation: 'Upsert',
    chain: '',
    fileType: '',
    owners: [],
    limitedOwners: [],
};

export const operationFieldValues = ['Upsert', 'Create', 'Update', 'Patch'];

export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
    },
    bodyContainer: {
        mt: 2,
        mx: '143.5px',
    },
    containerWidth: {
        width: '100%',
        mt: 2,
    },
    dragAndDropContainerWidth: {
        width: '100%',
        mt: 2,
        my: 2,
    },
    labelStyles: {
        ...themeObject.typography.inputLabel,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
    autoCompleteStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    checkboxHeaderStyles: {
        ...themeObject.typography.Components.menuItem,
        lineHeight: '27px',
        color: themeObject.palette.grayScale[800],
    },
    checkboxSubtitleStyles: {
        ...themeObject.typography.captions.default,
        ...themeObject.typography.captions.regular,
        lineHeight: '15.88px',
        color: themeObject.palette.grayScale[800],
    },
};
